import axios from "axios";

const getIisVistingSatisfaction = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/analytic/api/v1/scgp/iis-visting-satisfaction", {
        start_date: payload.start_date,
        end_date: payload.end_date,
        is_today: payload.is_today,
        is_month: payload.is_month,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
};

export default getIisVistingSatisfaction;
